import PinchZoom from 'pinch-zoom-js';
import { getScreenSize, mediaBreakpoints } from '../utils/helpers';
const isMobile = getScreenSize(mediaBreakpoints.mobileMax);

const elements = {
    $document: $(document),
    $body: $('body'),
    $zoomedWrapper: $('.js-zoomed-image')
};

const classes = {
    isOpen: 'is-open',
    scrollDisabled: 'scroll-disabled'
};

const selectors = {
    zoomImage: '.js-zoom-image',
    closeImageBtn: '.js-close-zoom-btn',
    productImage: '.js-product-image'
};

/**
 * Shared function for Product gallery zoom
 */
function zoomedProduct() {
    const { $document, $zoomedWrapper } = elements;
    const { zoomImage, closeImageBtn, productImage } = selectors;

    var $zoomedImage = elements.$zoomedWrapper.find(zoomImage);
    /**
     * Function to zoom into activeElement
     * @param {any} $activeElement Element containing zoom image on data-zoom and data-large
     */
    function zoom($activeElement) {
        var zoomUrlDesktop = $activeElement.data('zoom');
        var zoomUrlMobile = $activeElement.data('large');

        openZoomImage(true, $zoomedWrapper);

        if (!isMobile) {
            // Get zoomed image for desktop and handle image on Y offset
            $zoomedImage.css('background-image', `url(${zoomUrlDesktop})`);

            $document.on('mousemove', zoomImage, function (e) {
                var $this = $(this);
                var moveY = (e.clientY / $(this).height()) * 100;
                $this.css('background-position-y', moveY + '%');
            });

            $document.on('click', zoomImage, function () {
                openZoomImage(false, $zoomedWrapper);
            });
        } else {
            // Get large image for mobile devices
            $zoomedImage.css('background-image', `url(${zoomUrlMobile})`);
        }
    }

    // Close on mobile devices
    $document.on('click', closeImageBtn, function () {
        openZoomImage(false, $zoomedWrapper);
    });

    var pinchZoom = new PinchZoom($zoomedImage[0]);

    $document.on('click', productImage, function () {
        var $activeElement = $(this);

        zoom($activeElement);

        if (pinchZoom) {
            pinchZoom.update({
                type: 'load'
            });
        }
    });
}

/**
 * Handles open/close state of an image
 * @param {boolean} state - true/false to track open/close state of zoomed image
 * @param {Object} element - jQuery element - zoomed image
 */
function openZoomImage(state, element) {
    const { isOpen, scrollDisabled } = classes;
    const { $body } = elements;

    if (state) {
        element.addClass(isOpen);
        $body.addClass(scrollDisabled);
    } else {
        element.removeClass(isOpen);
        $body.removeClass(scrollDisabled);
    }
}

/**
 * Initialize the function
 */
function init() {
    zoomedProduct();
}

export default {
    init
};
